import Helpers from "../../commons/helpers";
import MessageClient from "../message/MessageClient";

import { AxiosRequestConfig } from "axios";
import { Constants } from "../../constants/constants";
import { IPagedList } from "../../commons/interfaces";
import { IDataCreateUpdate, IDetailRequest, IRecordPost } from "../../containers/post/usePost";


const PostService = {

    getPaged: async (query: any, extraLang?: string): Promise<IPagedList<IRecordPost>> => {
        const queryString = Helpers.handleFormatParams(query);
        const requestConfig: AxiosRequestConfig = !Helpers.isNullOrEmpty(extraLang)
            ? { headers: { "Accept-Language": extraLang } }
            : null;

        const result = await MessageClient().get(
            Constants.ApiPath.POST.GET_PAGED + `?${queryString}`,
            requestConfig
        );
        return result.data.result;
    },

    getDetail: async (query: IDetailRequest, extraLang?: string): Promise<IRecordPost> => {
        const queryString = Helpers.handleFormatParams(query);
        const requestConfig: AxiosRequestConfig = !Helpers.isNullOrEmpty(extraLang)
            ? { headers: { "Accept-Language": extraLang } }
            : null;

        const result = await MessageClient().get(
            Constants.ApiPath.POST.GET_DETAIL + `?${queryString}`,
            requestConfig
        );
        return result.data.result;
    },

    create: async (data: IDataCreateUpdate) => {
        const result = await MessageClient().post(
            Constants.ApiPath.POST.CREATE,
            data
        );
        return result.data.result;
    },

    update: async (data: IDataCreateUpdate) => {
        const result = await MessageClient().put(
            Constants.ApiPath.POST.UPDATE,
            data
        );
        return result.data.result;
    },

    publish: async (data: any) => {
        const result = await MessageClient().put(
            Constants.ApiPath.POST.PUBLISH,
            data
        );
        return result.data.result;
    },

    unpublish: async (id: string) => {
        const result = await MessageClient().put(
            `${Constants.ApiPath.POST.UNPUBLISH}/${id}`
        );
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(
            `${Constants.ApiPath.POST.DELETE}/${id}`
        );
        return result.data.result;
    },
}

export default PostService;